import { State } from "./types";
import { Cmd } from "@typescript-tea/core";
import { BaseState } from "../../../state";
import { Action } from "./action";
import * as LoadGroup from "../load-group";

import * as SharedState from "../../../../shared-state";
// import * as SystemOverride from "../../../components/settings-overrides";
import { InitialLoadConfig } from "../../../tools";
import { MoistureHeatLoadTypeEnum } from "@genesys/graphql-types";

export const init = (
  baseState: BaseState,
  initialLoadSettings: ReadonlyArray<InitialLoadConfig>
): readonly [State, Cmd<Action>?, SharedState.Action?] => {
  const loadSettingsMap = initialLoadSettings.reduce((sofar, current) => {
    const currentLoads = sofar[current.loadType] || [];
    return {
      ...sofar,
      [current.loadType]: [...currentLoads, current]
    };
  }, {} as Record<MoistureHeatLoadTypeEnum, Array<InitialLoadConfig>>);

  return [
    {
      ...baseState,
      currentPageTab: "moisture-heat-load-types",
      selectedLoadGroup: undefined,
      viewModeState: { viewMode: "grid" },
      loadGroupState: Object.keys(loadSettingsMap).reduce((sofar, current) => {
        const loads = loadSettingsMap[current as MoistureHeatLoadTypeEnum];
        return {
          ...sofar,
          [current]: LoadGroup.init(
            current as MoistureHeatLoadTypeEnum,
            0, // TOD0,
            loads,
            baseState.moistureLoadClaimValue!,
            baseState.propertyDefinitions!
          )
        };
      }, {} as Record<MoistureHeatLoadTypeEnum, LoadGroup.State>)
    }
  ];
};
